import { render, staticRenderFns } from "./AddSpecimen.vue?vue&type=template&id=6decf787&scoped=true"
import script from "./AddSpecimen.vue?vue&type=script&lang=js"
export * from "./AddSpecimen.vue?vue&type=script&lang=js"
import style0 from "./AddSpecimen.vue?vue&type=style&index=0&id=6decf787&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6decf787",
  null
  
)

export default component.exports